import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const mqttPublishUiNodeSpec: UiNodeSpec<'mqttPublish'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'trigger', 'topic', 'payload' ],
    }),
    cfg: () => ({ controlValues: { qos: 0, retain: false }, id: getUID(), kind: 'mqttPublish', disabled: false }),
    controls: getNodeCfg => ({
        qos: {
            cfg: {
                items: [
                    { label: '0', value: 0 },
                    { label: '1', value: 1 },
                    { label: '2', value: 2 },
                ],
                kind: 'selection',
                label: 'QoS',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.qos,
        },
        retain: { cfg: { kind: 'boolean', label: 'Retain' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.retain },
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        payload: ({
            control: {
                cfg: { kind: 'text', nullable: true },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.payload || '',
            },
            socket: ('string'),
            label: 'Message',
        }),
        topic: ({
            control: {
                cfg: { kind: 'text', nullable: true },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.topic || '',
            },
            socket: ('string'),
            label: 'Topic',
        }),
    }),
    kindLabel: 'MQTT Publish',
    nodeCategory: 'external',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
    }),
    validator: () => true,
};
